export default {
  state: {
    appName: "会员管理系统",  // 应用名称
    themeColor: "#053E99",  // 主题颜色
    oldThemeColor: "#053E99",   // 上一次主题颜色
    collapse:false,  // 导航栏收缩状态
    menuRouteLoaded:false,    // 菜单和路由是否已经加载
    global:[]
  },
  getters: {
    collapse(state){// 对应着上面state
      return state.collapse
    }
  },
  mutations: {
    onCollapse(state){  // 改变收缩状态
      state.collapse = !state.collapse
    },
    setThemeColor(state, themeColor){  // 改变主题颜色
      state.oldThemeColor = state.themeColor
      state.themeColor = themeColor
    },
    menuRouteLoaded(state, menuRouteLoaded){  // 改变菜单和路由的加载状态
      state.menuRouteLoaded = menuRouteLoaded;
    },
    setOptions(state, data){  // 设置字典数据
      state.global[data.key] = data.value
    },
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js